<template>
  <div id="app">

    <router-view ref="child"/>
    <PopUp :show="success" @close="success = false; if(firstTime)goToPageFirstTime(pasos[pasosCompletados])">
            <template #body>
              <p>{{ success_msg }}</p>
            </template>
          </PopUp>
          <PopUp :show="error" @close="error = false; $router.push({ name: pasos[pasosCompletados], params: { firstTime: true } })">
            <template #body>
              <p>{{ error_msg }}</p>
            </template>
          </PopUp>
  </div>
</template>
<script>
import axios from "axios";
import PopUp from "./components/PopUp.vue";
export default ({
  components: { PopUp },
  data: function () {
    return {
      firstTime: false,
      pasosCompletados: 0,
      success: false,
      success_msg: "",
      error: false,
      error_msg: "",
      pasos: [
        'Perfil',
        'Infraestructura',
        'Servicios',
        'Especialidades',
        'RegistrarMesa',
        'Horarios',
        'Imagenes',
        'ImagenesMenu',        
      ]
    }
  },
  methods: {
    obtenerPasoActual() {
      this.firstTime = false,
      this.pasosCompletados = 0
      let email = localStorage.getItem("email");
      if(!email) {
        return;
      }
      axios
        .get("/getPasosCompletosRegistro?mail=" + encodeURIComponent(email))
        .then((data) => {
          this.pasosCompletados = data.data;
          if(this.$refs.child){
            this.$refs.child.pasosCompletados = this.pasosCompletados;
          }
          let pasoPantallaActual = this.pasos.findIndex(x => x == this.$route.name);
          
          if(this.pasosCompletados < pasoPantallaActual) {
            if(this.pasosCompletados!=6){
              this.error_msg = "Debe completar los pasos previos para acceder a esta pagina, sera redireccionado a la pagina que debe completar automaticamente al cerrar este mensaje"
            this.error = true;
            }
          
          } else if(this.pasosCompletados != 8) {
            if(this.$refs.child){
              this.$refs.child.firstTime = true;
            }

          }
      });
    }
  },
  beforeUpdate() {
    this.obtenerPasoActual();
  },
  created() {
    if("verReservaConfirmacion"!=window.location.pathname.split("/").pop()){
      this.obtenerPasoActual();
    }

  },
})
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
